import React, { useCallback, useState, useRef } from 'react'
import PhoneForm from './PhoneForm'
import { sendSmsToPhone } from '../../../services/api'

const phoneRegex = new RegExp('^[0-9]{10}$')
const checkPhoneNumber = value => phoneRegex.test(value)

const Form = () => {
  const [isDisabled, setDisabled] = useState(true)
  const [isLoading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [infoText, setInfoText] = useState(null)
  const [value, setValue] = useState(null)
  const inputRef = useRef(null)

  const onChange = useCallback(value => {
    const isValid = checkPhoneNumber(value)
    setDisabled(!isValid)

    if (isValid) {
      setValue(value)
    }
  }, [])

  const onSubmit = useCallback(
    async e => {
      e.preventDefault()
      const isValueValid = checkPhoneNumber(value)

      if (isValueValid) {
        setLoading(true)
        const resp = await sendSmsToPhone({ phoneNumber: `+1${value}` })

        if (resp.ok) {
          if (inputRef.current?.maskRef?.value) {
            inputRef.current.maskRef.value = ''
          }
          setLoading(false)
          setError(null)
          setInfoText('Link sent successfully')

          setTimeout(() => {
            setInfoText(null)
          }, 3000)
        } else {
          const errorMessage =
            resp.data && resp.data.message
              ? resp.data.message
              : 'We have a problem :( Try again'
          setLoading(false)
          setInfoText(null)
          setError(errorMessage)
        }
      } else {
        setError('Phone number required')
      }
    },
    [value]
  )

  const inputProps = {
    placeholder: '+1 (212) 123 4567',
    type: 'phone',
    id: 'phone',
    required: true,
    mask: '+1 (000) 000 0000',
    unmask: true,
    onAccept: onChange,
    ref: inputRef,
  }

  const buttonProps = {
    disabled: isDisabled || isLoading,
    type: 'submit',
  }

  return (
    <PhoneForm
      inputProps={inputProps}
      buttonProps={buttonProps}
      onSubmit={onSubmit}
      error={error}
      infoText={infoText}
    />
  )
}

export default Form
